import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("title", component(opts));
  editor.BlockManager.add("title", block(opts));
};